import React, { useEffect, useState } from "react";
import { FaSpinner } from "react-icons/fa";
import Pagination from "../components/common/Pagination";
import { hideModal, showModal } from "../../src/utils/modalUtility";
import useAxios from "../utils/useAxios";
import config from "../config";
import { truncateWords } from "../utils/currencyFormat";
import TinyMCETextArea from "../components/common/TinyMCETextArea";

const Categories = () => {
  const [isEditMode, setIsEditMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentProjectId, setCurrentProjectId] = useState(null);
  const [projects, setProjects] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [uploadedMedia, setUploadedMedia] = useState([]);
  const [media, setMedia] = useState([]);
  const [mediaType, setMediaType] = useState("video"); // 'image' or 'video'
  const [selectedPreview, setSelectedPreview] = useState(null); //  preview URL
  const [categoryTypes, setCategoryTypes] = useState([]);

  const axiosAPI = useAxios();
  const BASE_URL = config?.apiBaseUrl;

  // const [selectedItems, setSelectedItems] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [slugError, setSlugError] = useState("");
  const [originalSlug, setOriginalSlug] = useState("");

  const [formData, setFormData] = useState({
    name: "",
    meta_title: "",
    meta_description: "",
    mediaIds: [],
    category_id: "",
    description: "",
    slug: "",
  });

  function removeFormData() {
    setFormData({
      name: "",
      category_id: "",
      meta_title: "",
      meta_description: "",
      mediaIds: [],
      description: "",
      slug: "",
    });
  }

  const handleChange = (e) => {
    const { id, value } = e.target;

    // setFormData((prev) => ({
    //   ...prev,
    //   [id]: value,
    // }));

    if (id === "name") {
      const slug = value.toLowerCase().replace(/\s+/g, "-");
      setFormData({
        ...formData,
        name: value,
        slug: slug,
      });
    } else {
      setFormData({
        ...formData,
        [id]: value,
      });
    }
  };
  const handleCheckboxChange = (id, file_path) => {
    // console.log("id and file path", id, file_path);

    setFormData((prevFormData) => {
      const alreadySelected = prevFormData.mediaIds.includes(id);

      let updatedMediaIds;

      // const updatedMediaIds = alreadySelected
      //   ? prevFormData.mediaIds.filter((item) => item !==   id) // deselect
      //   : [...prevFormData.mediaIds, id]; // select

      if (alreadySelected) {
        // Deselect
        updatedMediaIds = prevFormData.mediaIds.filter((item) => item !== id);
      } else {
        // Select
        updatedMediaIds = [...prevFormData.mediaIds, id];
      }
      //  Check if it's the first selected item (after adding)
      let newThumbnailUrl = prevFormData.thumbnail_url;

      if (!alreadySelected && prevFormData.mediaIds.length === 0) {
        // newThumbnailUrl = "/" + file_path;
        newThumbnailUrl = file_path;
      }

      // If first item is deselected, reset thumbnail_url (optional)
      if (alreadySelected && id === prevFormData.mediaIds[0]) {
        // Optional: You can reset or set to next selected item
        newThumbnailUrl = updatedMediaIds.length > 0 ? null : "";
      }

      return {
        ...prevFormData,
        mediaIds: updatedMediaIds,
        thumbnail_url: newThumbnailUrl,
      };
    });
  };

  // Get All Media
  const getMedia = async () => {
    try {
      const response = await axiosAPI.get("/api/media/get-media");
      // console.log(response.data.data);
      setMedia(response.data.data);

      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  async function fetchBlog() {
    try {
      setLoading(true);
      const response = await axiosAPI.get(
        `/api/categories/get-categories?page=${page}`,
      );
      setProjects(response?.data?.categories);
      setTotalPages(response?.data?.totalPages);
    } catch (error) {
      setProjects([]);
      console.error("Error fetching users:", error);
    } finally {
      // Always turn off loading, whether success or error
      setLoading(false);
    }
  }

  async function validateSlugUnique(slug) {
    try {
      const response = await axiosAPI.get(
        `/api/categories/check-slug-exist/${slug}`,
      );

      if (response.data.success) {
        // Slug is available
        setSlugError(""); // Clear error
        return true; // valid slug
      } else {
        // Slug already exists
        setSlugError(
          response.data.message ||
            "Slug already exists. Please choose a different one.",
        );
        return false; // invalid slug
      }
    } catch (error) {
      console.error("Error checking slug:", error);
      setSlugError("Error checking slug. Please try again.");
      return false; // consider invalid on error
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Start loading

    if (!formData.slug) {
      setSlugError("Slug is required");
      return;
    }

    if (!isEditMode || formData.slug !== originalSlug) {
      const isSlugValid = await validateSlugUnique(formData.slug);
      if (!isSlugValid) {
        setLoading(false); // important
        return;
      }
    }

    const payload = {
      name: formData.name,
      media_ids: formData.mediaIds,
      meta_title: formData.meta_title,
      meta_description: formData.meta_description,
      category_type_id: formData.category_id,
      description: formData.description,
      slug: formData.slug,
    };

    // console.log("Payload to ", payload);

    // setLoading(false);

    // return;

    try {
      let response;

      if (isEditMode) {
        response = await axiosAPI.put(
          `/api/categories/${currentProjectId}`,
          payload,
        );

        window.notifyMessage(
          "Success",
          "Category details updated successfully",
          "success",
        );
      } else {
        response = await axiosAPI.post(`/api/categories`, payload);
        window.notifyMessage(
          "Success",
          "Category details added successfully",
          "success",
        );
      }

      hideModal("newUserModal");
      removeFormData();
      fetchBlog(); // refresh list
    } catch (error) {
      const errorMsg = error?.response?.data?.message || "There was an error!";
      window.notifyMessage("Error", errorMsg, "danger");
    } finally {
      setLoading(false); // Stop loading in all cases
    }
  };

  const selectMediaFileToSend = (
    index,
    thumbnail_url,
    media_url,
    media_type,
  ) => {
    // console.log("Selected Media:");

    if (selectedItems.includes(index)) {
      setSelectedItems([]);
      setSelectedPreview(null);
    } else {
      setSelectedItems([index]);
      setSelectedPreview({
        thumbnail_url,
        media_url,
        media_type,
      });

      // console.log("Selected Preview Set:", {
      //   thumbnail_url,
      //   media_url,
      //   media_type,
      // });
    }
  };

  const openEditModal = (productId) => {
    setIsEditMode(true);
    setCurrentProjectId(productId);
    showModal("newUserModal");

    const productToEdit = projects.find((product) => product.id === productId);

    setFormData({
      name: productToEdit.name || "",
      meta_title: productToEdit.meta_title || "",
      meta_description: productToEdit.meta_description || "",
      category_id: productToEdit.category_type_id || "",
      description: productToEdit.description || "",
      slug: productToEdit.slug || "",
      mediaIds: productToEdit.media_id
        ? [productToEdit.media_id] //  wrap number in array
        : [],
    });

    setOriginalSlug(productToEdit.slug);
  };

  // console.log("FormData", formData);

  const handleDelete = async (id) => {
    const isConfirmed = window.confirm("Are you sure you want to delete this?");
    if (!isConfirmed) return;

    try {
      const response = await axiosAPI.delete(`/api/categories/${id}`);
      window.notifyMessage("Success", "Deleted successfully", "success");
      fetchBlog();
    } catch (error) {
      console.error("Error deleting:", error);
      window.notifyMessage(
        "Error",
        "An error occurred while deleting.",
        "danger",
      );
    }
  };

  // console.log("fomrData", formData);

  async function changeProjectStatus(e, projectId) {
    const currentStatus = e.target.value;

    // console.log("product  Id", blogId);
    // console.log("Current Status", currentStatus);

    try {
      const isConfirmed = window.confirm(
        "Are you sure you want to change the product card status?",
      );
      if (!isConfirmed) return;

      const response = await axiosAPI.put(
        `/api/blogs/change-blog-status/${projectId}`,
        { status: currentStatus },
      );

      fetchBlog();
      window.notifyMessage(
        "Success",
        "Product status changed successfully",
        "success",
      );
    } catch (error) {
      console.error("Error changing product status:", error);
      window.notifyMessage(
        "Error",
        "Failed to change product status. Please try again.",
        "danger",
      );
    }
  }

  function openMediaLibraryModal() {
    showModal("customModal");
  }

  function handleMediaSumbit() {
    // console.log("Media Ids", formData.mediaIds);
    hideModal("customModal");
  }
  function openBlogModal() {
    showModal("newUserModal");
  }

  const closeModal = () => {
    setIsEditMode(false);
    removeFormData();
    setCurrentProjectId(null);
  };

  const getCategoryTypes = async () => {
    try {
      const response = await axiosAPI.get(
        "/api/category-types/get-category-types",
      );
      // console.log("Category Types", response.data.data);
      setCategoryTypes(response?.data?.categories);
    } catch (error) {
      console.error("Error fetching category types:", error);
    }
  };

  // console.log("Category Types", categoryTypes);

  useEffect(() => {
    getMedia();
    getCategoryTypes();
  }, []);

  useEffect(() => {
    fetchBlog();
  }, []);

  useEffect(() => {
    fetchBlog();
  }, [page]);

  return (
    <div className="container">
      <div className="page-inner">
        <div className="d-flex justify-content-end align-items-end flex-column flex-md-row">
          <div>
            <button
              type="button"
              className="btn btn-dark btn-round mb-4"
              onClick={() => openBlogModal()}
            >
              Add Category
            </button>
          </div>
        </div>

        <div
          className="modal fade"
          id="newUserModal"
          tabIndex="-1"
          aria-labelledby="newUserModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="newUserModalLabel">
                  {isEditMode ? "Edit Category" : "Add Category"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={closeModal}
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleSubmit}>
                  {/* Blog Title */}
                  <div className="mb-3">
                    <label htmlFor="name" className="form-label">
                      Name *
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="name"
                      placeholder="Enter category name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  {/* Category Select */}
                  <div className="mb-3">
                    <label htmlFor="category_id" className="form-label">
                      Category Type *
                    </label>

                    <select
                      className="form-control"
                      id="category_id"
                      name="category_id"
                      value={formData.category_id}
                      onChange={handleChange}
                      required
                    >
                      <option value="" disabled>
                        -- Select Category --
                      </option>

                      {categoryTypes?.map((cat) => (
                        <option key={cat.id} value={cat.id}>
                          {cat.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="mb-3">
                    <label htmlFor="description" className="form-label">
                      Description *
                    </label>

                    <textarea
                      className="form-control"
                      id="description"
                      name="description"
                      placeholder="Enter product description"
                      value={formData.description}
                      onChange={handleChange}
                      rows="4"
                      required
                    />
                  </div>

                  {/* <TinyMCETextArea
                    id="description"
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                    rows={6} // optional
                  /> */}

                  {/* Slug */}
                  <div className="mb-3">
                    <label htmlFor="slug" className="form-label">
                      Slug *
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="slug"
                      placeholder="Enter category slug"
                      value={formData.slug}
                      onChange={handleChange}
                      required
                    />

                    {slugError && (
                      <small className="text-danger">{slugError}</small>
                    )}
                  </div>

                  {/* Category SEO Section */}
                  <div className="border rounded p-3 mt-4 bg-light">
                    <h6 className="text-primary mb-1">🔍 SEO Details</h6>
                    <p
                      className="text-muted mb-3"
                      style={{ fontSize: "0.85rem" }}
                    >
                      These fields help optimize your category page for search
                      engines.
                    </p>

                    {/* Category Meta Title */}
                    <div className="mb-3">
                      <label htmlFor="meta_title" className="form-label">
                        Meta Title *
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="meta_title"
                        placeholder="Enter category meta title"
                        value={formData.meta_title}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    {/* Category Meta Description */}
                    <div className="mb-0">
                      <label htmlFor="meta_description" className="form-label">
                        Meta Description *
                      </label>
                      <textarea
                        className="form-control"
                        id="meta_description"
                        placeholder="Enter category meta description"
                        value={formData.meta_description}
                        onChange={handleChange}
                        rows={4}
                        required
                      ></textarea>
                    </div>
                  </div>

                  <h6>Total Media selected : {formData.mediaIds?.length}</h6>
                  <div className="dropdown mb-3">
                    <button
                      className="btn theme-secondary-button btn-sm btn-rounded"
                      type="button"
                      id="dropdownMenuButton"
                      onClick={openMediaLibraryModal}
                      aria-expanded="false"
                    >
                      <i className="fas fa-photo-video me-1"></i>
                      Select Media From Gallery
                    </button>
                  </div>

                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn theme-secondary-button btn-sm btn-rounded"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>
                  </div>
                  <button
                    type="submit"
                    className="btn theme-button btn-sm btn-rounded"
                    disabled={loading}
                  >
                    {loading ? (
                      <FaSpinner className="spinner" spin />
                    ) : isEditMode ? (
                      "Update Category"
                    ) : (
                      "Add Category"
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="customModal"
          tabIndex="-1"
          aria-labelledby="customModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog  modal-dialog-centered modal-lg modal-dialog-scrollable">
            <div className="modal-content">
              {/* Modal Header */}
              <div className="modal-header">
                <h5 className="modal-title" id="customModalLabel">
                  {mediaType === "video" ? "Media Library" : "Media Library"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              {/* Modal Body */}
              <div className="modal-body">
                {/* Top Bar */}
                <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                  <input
                    type="text"
                    className="form-control w-50"
                    placeholder="Search media..."
                    // onChange={(e) => setSearch(e.target.value)}
                  />
                </div>
                {/* Upload Section */}
                <div className="media-grid row">
                  {media?.map((item, index) => {
                    const isChecked = formData.mediaIds?.includes(item.id);

                    return (
                      <div className="col-md-3 mb-4" key={index}>
                        <div className="card h-100">
                          <div className="position-relative">
                            {/* Show image or video based on type */}
                            {item.media_type === "video" ? (
                              <video
                                src={`${BASE_URL}${item.file_path}`}
                                controls
                                loop
                                muted
                                className="card-img-top"
                                style={{ height: "160px", objectFit: "cover" }}
                              />
                            ) : (
                              <img
                                src={`${BASE_URL}${item?.file_path}`}
                                alt={item.media_name}
                                className="card-img-top"
                                style={{ height: "160px", objectFit: "cover" }}
                              />
                            )}

                            {/* Checkbox */}
                            <div className="position-absolute top-0 end-0 p-2">
                              <input
                                type="checkbox"
                                checked={isChecked}
                                onChange={() =>
                                  handleCheckboxChange(item.id, item.file_path)
                                }
                              />
                            </div>
                          </div>

                          <div className="card-body p-2 text-center">
                            <small className="text-muted">
                              {item.media_name}
                            </small>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
                {/* Modal Inside Contain Image and Video */}
                {/* <div className="row g-3"> */}
                <div>
                  {uploadedMedia
                    .filter((item) => item.media_type === mediaType)
                    .map((item, index) => {
                      const isSelected = selectedItems.includes(index);
                      return (
                        <div className="col-6 col-md-3" key={index}>
                          <div
                            className="border rounded p-2 text-center position-relative"
                            style={{
                              cursor: "pointer",
                              maxWidth: "180px",
                              height: "130px",
                              margin: "0 auto",
                            }}
                            onClick={() =>
                              selectMediaFileToSend(
                                index,
                                item.thumbnail_url,
                                item.media_url,
                                item.media_type,
                              )
                            }
                          >
                            {/*  Fixed Selection Box */}
                            <div
                              style={{
                                position: "absolute",
                                top: "5px",
                                left: "5px",
                                width: "20px",
                                height: "20px",
                                backgroundColor: "white",
                                border: "2px solid #999",
                                borderRadius: "4px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                zIndex: 2,
                                fontSize: "14px",
                                fontWeight: "bold",
                              }}
                            >
                              {isSelected ? "" : ""}
                            </div>

                            {item.media_type === "image" ? (
                              <img
                                src={item.thumbnail_url}
                                alt={`media-${index}`}
                                style={{
                                  width: "100px",
                                  height: "100px",
                                  objectFit: "contain", // contain or contain based on your need
                                  borderRadius: "4px",
                                }}
                              />
                            ) : (
                              <video
                                src={item.media_url}
                                style={{
                                  width: "100px",
                                  height: "100px",
                                  objectFit: "contain",
                                  borderRadius: "4px",
                                }}
                                muted
                                loop
                                playsInline
                              />
                            )}
                          </div>
                        </div>
                      );
                    })}
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn theme-secondary-button btn-sm btn-rounded"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>

                  <button
                    type="button"
                    className="btn theme-button btn-sm btn-rounded"
                    // data-bs-toggle="modal"
                    // data-bs-target="#customModal"
                    onClick={handleMediaSumbit}
                    // disabled={!selectedPreview}
                  >
                    Select Media From Library
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Blogs Table */}
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">
                  All Categories ({projects?.length})
                </h4>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Sr no</th>
                        <th>Name</th>
                        <th>Description</th>
                        <th>Slug</th>
                        {/* <th>Meta Title</th> */}
                        {/* <th>Meta Title</th> */}
                        {/* <th>Status</th> */}
                        {/* <th>Created At</th> */}
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="6" className="text-center">
                            Loading...
                          </td>
                        </tr>
                      ) : projects?.length === 0 ? (
                        <tr>
                          <td colSpan="6" className="text-center">
                            No Categories found.
                          </td>
                        </tr>
                      ) : (
                        projects &&
                        projects?.map((project, index) => (
                          <tr key={project.id}>
                            <td>{index + 1}</td>
                            <td>{project?.name}</td>
                            <td>{truncateWords(project?.description, 10)}</td>
                            <td>{project?.slug}</td>
                            {/* <td>{project?.description}</td> */}
                            {/* <td>
                              <select
                                className="form-select"
                                value={project.is_active_or_inactive}
                                onChange={(e) =>
                                  changeProjectStatus(e, project?.id)
                                }
                              >
                                <option value="YES">Yes</option>
                                <option value="NO">No</option>
                              </select>
                            </td> */}
                            {/* <td>
                              {new Date(
                                project?.created_at_utc + "Z",
                              )?.toLocaleString()}
                            </td> */}
                            <td>
                              <button
                                className="btn btn-icon btn-round btn-dark btn-sm me-2"
                                onClick={() => openEditModal(project.id)}
                              >
                                <i className="fas fa-edit"></i>
                              </button>
                              <button
                                className="btn btn-icon btn-round btn-danger btn-sm me-2"
                                onClick={() => handleDelete(project.id)}
                              >
                                <i className="fas fa-trash"></i>
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <Pagination totalPages={totalPages} setPage={setPage} page={page} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Categories;
